// Language translations for EN and AR

export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      callUs: 'Call Us',
      getQuote: 'Get Quote',
    },
    
    // Home Page
    home: {
      heroTitle: 'Your Trusted Partner for',
      heroTitleHighlight: 'Premium Staffing',
      heroSubtitle: 'Professional domestic and labor services across the UAE. From nannies to security guards, we provide skilled, verified staff for all your needs.',
      getQuoteWhatsApp: 'Get Quote on WhatsApp',
      callNow: 'Call Now',
      ourServices: 'Our Services',
      servicesSubtitle: 'Comprehensive staffing solutions for homes, businesses, and farms',
      viewAllServices: 'View All Services',
      whyChooseUs: 'Why Choose',
      whyChooseUsHighlight: 'TDABYR ALMSTQBL',
      whyChooseUsSubtitle: 'We set the standard for professional staffing services in the UAE',
      readyToFind: 'Ready to Find the',
      perfectStaff: 'Perfect Staff?',
      freeConsultation: 'Free consultation and assessment',
      quickPlacement: 'Quick placement within 48 hours',
      replacementGuarantee: 'Replacement guarantee',
      support247: '24/7 customer support',
      whatsAppUs: 'WhatsApp Us',
      contactUs: 'Contact Us',
    },
    
    // Services
    services: {
      pageTitle: 'Our',
      pageTitleHighlight: 'Services',
      pageSubtitle: 'Comprehensive domestic and labor staffing solutions tailored to your needs. All our staff are verified, trained, and ready to serve.',
      enquireNow: 'Enquire Now',
      callUs: 'Call Us',
      cantFind: "Can't Find What You're Looking For?",
      cantFindSubtitle: "Contact us for custom staffing solutions. We'll help you find the perfect match for your specific requirements.",
      chatOnWhatsApp: 'Chat on WhatsApp',
      payInInstallments: 'Pay in easy installments',
      
      // Service items
      nannies: {
        title: 'Nannies & Babysitters',
        description: 'Professional and caring nannies to look after your children with love and dedication. Our nannies are trained in child development and safety.',
        features: ['Child care expertise', 'First aid certified', 'Background verified', 'Multilingual options'],
      },
      housemaids: {
        title: 'Housemaids',
        description: 'Experienced housemaids to maintain your home in pristine condition. From cleaning to organizing, they handle all household chores efficiently.',
        features: ['Deep cleaning', 'Laundry & ironing', 'Kitchen maintenance', 'Organizing services'],
      },
      security: {
        title: 'Security Guards',
        description: 'Professional security personnel to protect your home, office, or event. Trained in security protocols and emergency response.',
        features: ['24/7 surveillance', 'Access control', 'Emergency response', 'Event security'],
      },
      cooks: {
        title: 'Cooks & Chefs',
        description: 'Skilled culinary professionals to prepare delicious meals. From everyday cooking to special occasions, our chefs deliver excellence.',
        features: ['Multi-cuisine expertise', 'Meal planning', 'Diet-specific cooking', 'Event catering'],
      },
      drivers: {
        title: 'Drivers',
        description: 'Professional and reliable drivers for personal or family transportation needs. Licensed, experienced, and committed to safety.',
        features: ['Valid UAE license', 'Route planning', 'Vehicle maintenance', 'School pickups'],
      },
      teachers: {
        title: 'Private Teachers',
        description: 'Qualified educators for home tutoring and educational support. Personalized learning plans for students of all ages.',
        features: ['Subject specialists', 'Exam preparation', 'Language tutoring', 'Special education'],
      },
      caregivers: {
        title: 'Caregivers',
        description: 'Compassionate caregivers for elderly and special needs individuals. Professional care with dignity and respect.',
        features: ['Elder care', 'Medical assistance', 'Companion care', 'Mobility support'],
      },
      farmers: {
        title: 'Farmers & Gardeners',
        description: 'Experienced agricultural workers and gardeners for farms and landscaping. Expert knowledge in cultivation and maintenance.',
        features: ['Crop cultivation', 'Landscaping', 'Irrigation management', 'Organic farming'],
      },
    },
    
    // About Page
    about: {
      pageTitle: 'About',
      pageTitleHighlight: 'Us',
      pageSubtitle: 'Discover our story, mission, and commitment to excellence in staffing services.',
      servingSince: 'Serving UAE Since 2014',
      companyIntro: 'is a premier staffing and domestic services company based in the United Arab Emirates. With over a decade of experience, we have established ourselves as a trusted name in providing skilled, verified, and professional staff for homes, businesses, and farms across the UAE.',
      companyIntro2: 'Our comprehensive range of services includes nannies, housemaids, security guards, cooks, drivers, teachers, caregivers, and farmers. Each member of our staff undergoes rigorous screening and training to ensure they meet our high standards of professionalism and reliability.',
      companyIntro3: 'We take pride in our commitment to excellence and our ability to match the right staff with the right families and businesses. Our dedicated support team is available around the clock to ensure complete satisfaction.',
      yourPartner: 'Your Staffing Partner in the UAE',
      ourMission: 'Our Mission',
      missionText: 'To provide exceptional staffing solutions that enhance the quality of life for families and efficiency for businesses across the UAE. We are committed to connecting skilled, reliable professionals with those who need them, ensuring trust, safety, and satisfaction in every placement.',
      ourVision: 'Our Vision',
      visionText: 'To be the most trusted and preferred staffing partner in the UAE and the wider Middle East region. We envision a future where every home and business has access to professional, verified staff who contribute positively to their daily lives and operations.',
      coreValues: 'Our Core',
      coreValuesHighlight: 'Values',
      coreValuesSubtitle: 'The principles that guide everything we do',
      ourJourney: 'Our',
      ourJourneyHighlight: 'Journey',
      ourJourneySubtitle: 'Key milestones in our growth story',
      readyToWork: 'Ready to Work With Us?',
      readyToWorkSubtitle: 'Contact us today to discuss your staffing needs. We\'re here to help you find the perfect match.',
      getInTouch: 'Get in Touch',
      
      // Values
      values: {
        trust: { title: 'Trust & Reliability', description: 'We build lasting relationships through consistent, dependable service delivery.' },
        people: { title: 'People First', description: 'Our staff and clients are at the heart of everything we do.' },
        excellence: { title: 'Excellence', description: 'We strive for the highest standards in staffing and service quality.' },
        integrity: { title: 'Integrity', description: 'Honest, transparent dealings with all our stakeholders.' },
      },
      
      // Timeline
      timeline: {
        year2014: { event: 'Company Founded', description: 'Started with a vision to transform staffing services in the UAE.' },
        year2016: { event: 'Expanded Services', description: 'Added security, driving, and caregiving services to our portfolio.' },
        year2019: { event: '500+ Clients', description: 'Reached a milestone of serving over 500 satisfied clients.' },
        year2024: { event: '10 Years Strong', description: 'Celebrating a decade of trusted staffing solutions.' },
      },
    },
    
    // Contact Page
    contact: {
      pageTitle: 'Contact',
      pageTitleHighlight: 'Us',
      pageSubtitle: 'Fast response via WhatsApp & Phone',
      fastResponse: 'Fast Response',
      uaeSupport: 'UAE-Based Support',
      secureProf: 'Secure & Professional',
      
      // Contact cards
      mainOffice: 'Main Office',
      landline: 'Landline',
      shoppingDept: 'Shopping Department',
      salesInquiries: 'Sales & Inquiries',
      management: 'Management',
      directLines: 'Direct Lines',
      emailUs: 'Email Us',
      generalInquiries: 'General Inquiries',
      sendEmail: 'Send Email',
      workingHours: 'Mon–Sat: 9:00 AM – 6:00 PM',
      closedDay: 'Sunday: Closed',
      
      // Form
      sendMessage: 'Send Us a Message',
      formSubtitle: 'Fill out the form and we\'ll reply as soon as possible.',
      serviceRequired: 'Service Required',
      selectService: 'Select a service...',
      fullName: 'Full Name',
      yourName: 'Your full name',
      phoneNumber: 'Phone Number',
      yourMessage: 'Your Message',
      messagePlaceholder: 'Tell us about your requirements...',
      replyNote: 'We reply as soon as possible during working hours.',
      send: 'Send Message',
      sending: 'Sending...',
      secureNote: 'Your information is secure and will not be shared.',
      
      // CTA
      needImmediate: 'Need Immediate Assistance?',
      needImmediateSubtitle: 'Chat with our team on WhatsApp for the fastest response.',
      chatNow: 'Chat on WhatsApp Now',
      
      // Toast
      messageSent: 'Message Sent Successfully!',
      messageSuccess: 'We will contact you as soon as possible.',
    },
    
    // Map Section
    map: {
      ourLocation: 'Our Location',
      findUs: 'Find Us on Google Maps',
      floor: '9th Floor – Office 901',
      openMaps: 'Open in Google Maps',
      getDirections: 'Get Directions',
      sharjah: 'Sharjah, UAE',
      floorOffice: 'Floor 9',
      office: 'Office 901',
    },
    
    // Footer
    footer: {
      description: 'Your trusted partner for professional domestic and labor services in the UAE. We connect you with skilled, reliable staff for all your needs.',
      quickLinks: 'Quick Links',
      ourServices: 'Our Services',
      contactUs: 'Contact Us',
      mainOffice: 'Main Office',
      shoppingDept: 'Shopping Dept',
      management: 'Management',
      allRights: 'All rights reserved.',
      proudlyServing: 'Proudly serving the',
      uae: 'UAE',
    },
    
    // WhatsApp Button
    whatsapp: {
      needHelp: 'Need Help?',
      chatWithUs: 'Chat with us on WhatsApp for quick assistance!',
    },
    
    // Stats
    stats: {
      happyClients: 'Happy Clients',
      staffPlaced: 'Staff Placed',
      yearsExp: 'Years Experience',
      support: 'Support',
    },
    
    // Why Choose Us items
    whyChoose: {
      verified: { title: 'Verified Staff', description: 'All our staff undergo thorough background checks and verification processes.' },
      quick: { title: 'Quick Placement', description: 'Fast and efficient placement process to meet your urgent staffing needs.' },
      skilled: { title: 'Skilled Professionals', description: 'Highly trained and experienced professionals across all service categories.' },
      quality: { title: 'Quality Assurance', description: 'Continuous monitoring and support to ensure service excellence.' },
    },
  },
  
  ar: {
    // Navigation
    nav: {
      home: 'الرئيسية',
      services: 'خدماتنا',
      about: 'من نحن',
      contact: 'اتصل بنا',
      callUs: 'اتصل بنا',
      getQuote: 'احصل على عرض سعر',
    },
    
    // Home Page
    home: {
      heroTitle: 'شريكك الموثوق في',
      heroTitleHighlight: 'خدمات التوظيف المتميزة',
      heroSubtitle: 'خدمات منزلية وعمالة احترافية في جميع أنحاء الإمارات. من المربيات إلى حراس الأمن، نوفر لك كوادر ماهرة وموثوقة لجميع احتياجاتك.',
      getQuoteWhatsApp: 'احصل على عرض سعر عبر واتساب',
      callNow: 'اتصل الآن',
      ourServices: 'خدماتنا',
      servicesSubtitle: 'حلول توظيف شاملة للمنازل والشركات والمزارع',
      viewAllServices: 'عرض جميع الخدمات',
      whyChooseUs: 'لماذا تختار',
      whyChooseUsHighlight: 'تدابير المستقبل',
      whyChooseUsSubtitle: 'نضع المعايير لخدمات التوظيف الاحترافية في الإمارات',
      readyToFind: 'هل أنت مستعد للعثور على',
      perfectStaff: 'الموظف المثالي؟',
      freeConsultation: 'استشارة وتقييم مجاني',
      quickPlacement: 'توظيف سريع خلال 48 ساعة',
      replacementGuarantee: 'ضمان الاستبدال',
      support247: 'دعم على مدار الساعة',
      whatsAppUs: 'تواصل عبر واتساب',
      contactUs: 'اتصل بنا',
    },
    
    // Services
    services: {
      pageTitle: '',
      pageTitleHighlight: 'خدماتنا',
      pageSubtitle: 'حلول توظيف منزلية وعمالة شاملة مصممة لتلبية احتياجاتك. جميع موظفينا تم التحقق منهم وتدريبهم وجاهزون للخدمة.',
      enquireNow: 'استفسر الآن',
      callUs: 'اتصل بنا',
      cantFind: 'لم تجد ما تبحث عنه؟',
      cantFindSubtitle: 'تواصل معنا للحصول على حلول توظيف مخصصة. سنساعدك في العثور على المطابقة المثالية لمتطلباتك.',
      chatOnWhatsApp: 'تواصل عبر واتساب',
      payInInstallments: 'ادفع بالتقسيط',
      
      // Service items
      nannies: {
        title: 'مربيات وجليسات أطفال',
        description: 'مربيات محترفات وحنونات للعناية بأطفالك بكل حب وتفاني. مربياتنا مدربات على تنمية الطفل والسلامة.',
        features: ['خبرة في رعاية الأطفال', 'معتمدات في الإسعافات الأولية', 'تم التحقق من الخلفية', 'خيارات متعددة اللغات'],
      },
      housemaids: {
        title: 'خادمات منزل',
        description: 'خادمات ذوات خبرة للحفاظ على منزلك في حالة ممتازة. من التنظيف إلى التنظيم، يتعاملن مع جميع الأعمال المنزلية بكفاءة.',
        features: ['تنظيف عميق', 'غسيل وكي', 'صيانة المطبخ', 'خدمات التنظيم'],
      },
      security: {
        title: 'حراس أمن',
        description: 'أفراد أمن محترفون لحماية منزلك أو مكتبك أو فعاليتك. مدربون على بروتوكولات الأمن والاستجابة للطوارئ.',
        features: ['مراقبة على مدار الساعة', 'التحكم في الوصول', 'الاستجابة للطوارئ', 'أمن الفعاليات'],
      },
      cooks: {
        title: 'طباخون وشيفات',
        description: 'محترفون في الطهي لإعداد وجبات لذيذة. من الطبخ اليومي إلى المناسبات الخاصة، طهاتنا يقدمون التميز.',
        features: ['خبرة في مختلف المطابخ', 'تخطيط الوجبات', 'طهي حسب النظام الغذائي', 'تموين الفعاليات'],
      },
      drivers: {
        title: 'سائقون',
        description: 'سائقون محترفون وموثوقون لاحتياجات النقل الشخصية أو العائلية. مرخصون وذوو خبرة وملتزمون بالسلامة.',
        features: ['رخصة قيادة إماراتية سارية', 'تخطيط المسارات', 'صيانة المركبات', 'توصيل المدارس'],
      },
      teachers: {
        title: 'معلمون خصوصيون',
        description: 'مدرسون مؤهلون للتدريس المنزلي والدعم التعليمي. خطط تعلم مخصصة للطلاب من جميع الأعمار.',
        features: ['متخصصون في المواد', 'التحضير للامتحانات', 'تدريس اللغات', 'التعليم الخاص'],
      },
      caregivers: {
        title: 'مقدمو رعاية',
        description: 'مقدمو رعاية رحومون لكبار السن وذوي الاحتياجات الخاصة. رعاية احترافية بكرامة واحترام.',
        features: ['رعاية كبار السن', 'المساعدة الطبية', 'رعاية مرافقة', 'دعم الحركة'],
      },
      farmers: {
        title: 'مزارعون وبستانيون',
        description: 'عمال زراعيون وبستانيون ذوو خبرة للمزارع وتنسيق الحدائق. معرفة خبيرة في الزراعة والصيانة.',
        features: ['زراعة المحاصيل', 'تنسيق الحدائق', 'إدارة الري', 'الزراعة العضوية'],
      },
    },
    
    // About Page
    about: {
      pageTitle: 'من',
      pageTitleHighlight: 'نحن',
      pageSubtitle: 'اكتشف قصتنا ورسالتنا والتزامنا بالتميز في خدمات التوظيف.',
      servingSince: 'نخدم الإمارات منذ 2014',
      companyIntro: 'هي شركة رائدة في التوظيف والخدمات المنزلية مقرها في الإمارات العربية المتحدة. مع أكثر من عقد من الخبرة، أسسنا أنفسنا كاسم موثوق في توفير كوادر ماهرة وموثوقة ومحترفة للمنازل والشركات والمزارع في جميع أنحاء الإمارات.',
      companyIntro2: 'تشمل مجموعة خدماتنا الشاملة المربيات والخادمات وحراس الأمن والطباخين والسائقين والمعلمين ومقدمي الرعاية والمزارعين. يخضع كل فرد من موظفينا لفحص وتدريب صارم لضمان استيفائهم لمعاييرنا العالية من الاحترافية والموثوقية.',
      companyIntro3: 'نفخر بالتزامنا بالتميز وقدرتنا على مطابقة الموظف المناسب مع العائلات والشركات المناسبة. فريق الدعم المخصص لدينا متاح على مدار الساعة لضمان الرضا التام.',
      yourPartner: 'شريكك في التوظيف في الإمارات',
      ourMission: 'رسالتنا',
      missionText: 'تقديم حلول توظيف استثنائية تعزز جودة الحياة للعائلات وكفاءة الشركات في جميع أنحاء الإمارات. نحن ملتزمون بربط المحترفين المهرة والموثوقين بمن يحتاجون إليهم، مع ضمان الثقة والسلامة والرضا في كل توظيف.',
      ourVision: 'رؤيتنا',
      visionText: 'أن نكون شريك التوظيف الأكثر ثقة وتفضيلاً في الإمارات ومنطقة الشرق الأوسط الأوسع. نتصور مستقبلاً يحصل فيه كل منزل وشركة على موظفين محترفين وموثوقين يساهمون بشكل إيجابي في حياتهم اليومية وعملياتهم.',
      coreValues: 'قيمنا',
      coreValuesHighlight: 'الأساسية',
      coreValuesSubtitle: 'المبادئ التي توجه كل ما نقوم به',
      ourJourney: '',
      ourJourneyHighlight: 'مسيرتنا',
      ourJourneySubtitle: 'معالم رئيسية في قصة نمونا',
      readyToWork: 'هل أنت مستعد للعمل معنا؟',
      readyToWorkSubtitle: 'تواصل معنا اليوم لمناقشة احتياجاتك من التوظيف. نحن هنا لمساعدتك في العثور على المطابقة المثالية.',
      getInTouch: 'تواصل معنا',
      
      // Values
      values: {
        trust: { title: 'الثقة والموثوقية', description: 'نبني علاقات دائمة من خلال تقديم خدمة متسقة ويمكن الاعتماد عليها.' },
        people: { title: 'الناس أولاً', description: 'موظفونا وعملاؤنا في قلب كل ما نفعله.' },
        excellence: { title: 'التميز', description: 'نسعى لأعلى المعايير في جودة التوظيف والخدمة.' },
        integrity: { title: 'النزاهة', description: 'تعاملات صادقة وشفافة مع جميع أصحاب المصلحة.' },
      },
      
      // Timeline
      timeline: {
        year2014: { event: 'تأسيس الشركة', description: 'بدأنا برؤية لتحويل خدمات التوظيف في الإمارات.' },
        year2016: { event: 'توسيع الخدمات', description: 'أضفنا خدمات الأمن والقيادة والرعاية إلى محفظتنا.' },
        year2019: { event: '+500 عميل', description: 'وصلنا إلى معلم خدمة أكثر من 500 عميل راضٍ.' },
        year2024: { event: '10 سنوات من القوة', description: 'نحتفل بعقد من حلول التوظيف الموثوقة.' },
      },
    },
    
    // Contact Page
    contact: {
      pageTitle: 'اتصل',
      pageTitleHighlight: 'بنا',
      pageSubtitle: 'استجابة سريعة عبر واتساب والهاتف',
      fastResponse: 'استجابة سريعة',
      uaeSupport: 'دعم من الإمارات',
      secureProf: 'آمن واحترافي',
      
      // Contact cards
      mainOffice: 'المكتب الرئيسي',
      landline: 'الهاتف الثابت',
      shoppingDept: 'قسم المبيعات',
      salesInquiries: 'المبيعات والاستفسارات',
      management: 'الإدارة',
      directLines: 'خطوط مباشرة',
      emailUs: 'راسلنا',
      generalInquiries: 'استفسارات عامة',
      sendEmail: 'إرسال بريد',
      workingHours: 'الإثنين–السبت: 9:00 ص – 6:00 م',
      closedDay: 'الأحد: مغلق',
      
      // Form
      sendMessage: 'أرسل لنا رسالة',
      formSubtitle: 'املأ النموذج وسنرد في أقرب وقت ممكن.',
      serviceRequired: 'الخدمة المطلوبة',
      selectService: 'اختر خدمة...',
      fullName: 'الاسم الكامل',
      yourName: 'اسمك الكامل',
      phoneNumber: 'رقم الهاتف',
      yourMessage: 'رسالتك',
      messagePlaceholder: 'أخبرنا عن متطلباتك...',
      replyNote: 'نرد في أقرب وقت ممكن خلال ساعات العمل.',
      send: 'إرسال الرسالة',
      sending: 'جاري الإرسال...',
      secureNote: 'معلوماتك آمنة ولن يتم مشاركتها.',
      
      // CTA
      needImmediate: 'تحتاج مساعدة فورية؟',
      needImmediateSubtitle: 'تواصل مع فريقنا عبر واتساب للحصول على أسرع استجابة.',
      chatNow: 'تواصل عبر واتساب الآن',
      
      // Toast
      messageSent: 'تم إرسال الرسالة بنجاح!',
      messageSuccess: 'سنتواصل معك في أقرب وقت ممكن.',
    },
    
    // Map Section
    map: {
      ourLocation: 'موقعنا',
      findUs: 'جدنا على خرائط جوجل',
      floor: 'الطابق 9 – مكتب 901',
      openMaps: 'افتح في خرائط جوجل',
      getDirections: 'احصل على الاتجاهات',
      sharjah: 'الشارقة، الإمارات',
      floorOffice: 'الطابق 9',
      office: 'مكتب 901',
    },
    
    // Footer
    footer: {
      description: 'شريكك الموثوق لخدمات العمالة المنزلية الاحترافية في الإمارات. نربطك بموظفين ماهرين وموثوقين لجميع احتياجاتك.',
      quickLinks: 'روابط سريعة',
      ourServices: 'خدماتنا',
      contactUs: 'اتصل بنا',
      mainOffice: 'المكتب الرئيسي',
      shoppingDept: 'قسم المبيعات',
      management: 'الإدارة',
      allRights: 'جميع الحقوق محفوظة.',
      proudlyServing: 'نخدم بفخر',
      uae: 'الإمارات',
    },
    
    // WhatsApp Button
    whatsapp: {
      needHelp: 'تحتاج مساعدة؟',
      chatWithUs: 'تواصل معنا عبر واتساب للحصول على مساعدة سريعة!',
    },
    
    // Stats
    stats: {
      happyClients: 'عميل سعيد',
      staffPlaced: 'موظف تم توظيفه',
      yearsExp: 'سنوات خبرة',
      support: 'دعم',
    },
    
    // Why Choose Us items
    whyChoose: {
      verified: { title: 'موظفون موثقون', description: 'يخضع جميع موظفينا لفحوصات خلفية شاملة وعمليات تحقق.' },
      quick: { title: 'توظيف سريع', description: 'عملية توظيف سريعة وفعالة لتلبية احتياجاتك العاجلة.' },
      skilled: { title: 'محترفون مهرة', description: 'محترفون مدربون وذوو خبرة عالية في جميع فئات الخدمات.' },
      quality: { title: 'ضمان الجودة', description: 'مراقبة ودعم مستمر لضمان تميز الخدمة.' },
    },
  },
};

export default translations;
